import { render, staticRenderFns } from "./membersRecord.vue?vue&type=template&id=c28e2314&"
import script from "./membersRecord.vue?vue&type=script&lang=js&"
export * from "./membersRecord.vue?vue&type=script&lang=js&"
import style0 from "./membersRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports